export const es = {
  "NAVIGATION": {
    "HOME": "Inicio",
    "PORTFOLIO": "Cartera",
    "PROFILE": "Perfil"
  },
  "HOME_SCREEN": {
    "SEARCH": {
      "PLACEHOLDER": "Buscar en ofertas disponibles",
      "TITLE": "Buscar solo en la sección de ofertas disponibles"
    },
    "QUICK_FILTERS": {
      "TITLE": "Filtros rápidos",
      "CAPTION": "Elegir categoría",
      "DEFI": "DeFi",
      "STAKING": "Staking",
      "FARMING": "Farming",
      "LENDING": "Préstamos",
      "MINING": "Minería",
      "TRADING": "Trading",
      "ALL": "Todos",
      "STABLECOINS": "Stablecoins",
      "DEPOSITS": "Depósitos",
      "DEXES": "DEX"
    },
    "PREMIUM_DEALS": {
      "TITLE": "Ofertas Premium",
      "CAPTION": "Las mejores ofertas de la semana",
      "NO_DEALS": "Sin ofertas",
      "NO_DEALS_AVAILABLE": "No hay ofertas disponibles",
      "GET_PREMIUM": "Obtener Premium",
      "APY": "Rendimiento anual",
      "NETWORK": "Red",
      "TOKEN_TYPE": "Tipo de token"
    },
    "FILTERS": {
      "TITLE": "Filtros",
      "FILTERS": "Filtros",
      "SELECT_FILTERS": "Seleccionar filtros",
      "APPLY": "Aplicar"
    },
    "AVAILABLE_DEALS": {
      "TITLE": "Ofertas disponibles",
      "CAPTION": "Nuevas oportunidades del mercado",
      "NO_DEALS": "No se encontraron oportunidades"
    }
  },
  "PROFILE_SCREEN": {
    "SUBSCRIPTION_STATUS": {
      "TITLE": "Estado de suscripción",
      "CAPTION": "Detalles de tu membresía premium",
      "ACTIVE": "ACTIVA",
      "INACTIVE": "INACTIVA",
      "PERIOD": "Período",
      "EXPIRES": "Vence",
      "PROGRESS": "Progreso de suscripción",
      "NOT_STARTED": "No iniciado"
    },
    "REFERRAL": {
      "TITLE": "Programa de referidos",
      "CAPTION": "Invita amigos y gana puntos",
      "RANK": "RANGO",
      "TOTAL_REFERRALS": "Total de referidos",
      "ACTIVE_REFERRALS": "Referidos activos",
      "REFERRALS_BY_LEVEL": "Referidos por nivel",
      "COPY": "Copiar",
      "POINTS_TO_NEXT_RANK": "{{points}} puntos para el siguiente rango"
    },
    "PREMIUM": {
      "TITLE": "Suscripción Premium",
      "CAPTION": "Elige un plan y obtén acceso a funciones premium",
      "MONTHS": "meses",
      "BEST_VALUE": "Mejor valor",
      "PAYMENT_METHOD": "Método de pago",
      "TELEGRAM_STARS": "Telegram Stars",
      "CRYPTO": "Criptomoneda",
      "YOU_SAVE": "Ahorras",
      "PROCESSING": "Procesando...",
      "PAY_STARS": "Pagar {{amount}} Stars",
      "PAY_CRYPTO": "Pagar ${{amount}} en cripto",
      "PAYMENT_SUCCESS": {
        "TITLE": "Pago exitoso",
        "MESSAGE": "¡Tu suscripción ha sido activada exitosamente!"
      },
      "PAYMENT_ERROR": {
        "TITLE": "Error de pago",
        "MESSAGE": "No se pudo procesar el pago. Por favor, intenta nuevamente.",
        "STARS_INSUFFICIENT": "Stars insuficientes para el pago. Por favor, recarga tu balance de stars a través de @PremiumBot."
      },
      "PAYMENT_CANCELLED": {
        "TITLE": "Pago cancelado",
        "MESSAGE": "Has cancelado el pago. Intenta nuevamente cuando estés listo."
      },
      "PAYMENT_PENDING": {
        "TITLE": "Procesando pago",
        "MESSAGE": "Tu pago está siendo procesado. Por favor, espera."
      },
      "BUTTONS": {
        "OK": "OK",
        "CANCEL": "Cancelar",
        "BUY_STARS": "Comprar Stars"
      }
    },
    "FEATURES": {
      "EARLY_ACCESS": "Acceso anticipado a ofertas Premium con alto APY",
      "EXCLUSIVE_DEFI": "Oportunidades DeFi exclusivas con APY de hasta 80%",
      "NOTIFICATIONS": "Notificaciones en tiempo real de nuevas ofertas Premium",
      "GUIDES": "Guías detalladas paso a paso y estrategias",
      "INSIGHTS": "Análisis y recomendaciones semanales del mercado"
    },
    "FOOTER": {
      "CONTACT": "Si tienes alguna pregunta, contáctanos en:",
      "EMAIL_COPIED": "Dirección de correo electrónico copiada al portapapeles",
      "SUPPORT_TITLE": "Soporte",
      "SUPPORT_CAPTION": "Contáctanos si tienes alguna pregunta",
      "EMAIL": "Correo electrónico",
      "TELEGRAM": "Telegram"
    },
    "LANGUAGE": {
      "TITLE": "Configuración de idioma",
      "CAPTION": "Elige tu idioma preferido",
      "LANGUAGES": {
        "EN": "Inglés",
        "RU": "Ruso",
        "UK": "Ucraniano",
        "ES": "Español",
        "AR": "Árabe",
        "ZH": "Chino"
      }
    }
  },
  "PORTFOLIO_STRATEGY_SCREEN": {
    "TITLE": "Estrategia de portafolio",
    "SUBTITLE": "Resumen de estrategias de portafolio disponibles",
    "STRATEGIES": {
      "CONSERVATIVE": {
        "NAME": "Preservación de capital",
        "DESCRIPTION": "Estrategia de bajo riesgo enfocada en preservar capital a través de stablecoins con rendimiento estable",
        "RISK_LEVEL": "Riesgo bajo"
      },
      "MODERATE": {
        "NAME": "Flujo de efectivo",
        "DESCRIPTION": "Estrategia de bajo riesgo enfocada en ingresos estables a través de stablecoins y criptomonedas principales",
        "RISK_LEVEL": "Riesgo bajo"
      },
      "BALANCED": {
        "NAME": "Balanceado",
        "DESCRIPTION": "Estrategia balanceada de riesgo moderado que incluye stablecoins, criptomonedas principales y altcoins seleccionadas",
        "RISK_LEVEL": "Riesgo moderado"
      },
      "AGGRESSIVE": {
        "NAME": "Crecimiento",
        "DESCRIPTION": "Estrategia de alto riesgo enfocada en criptomonedas principales y altcoins prometedoras",
        "RISK_LEVEL": "Riesgo alto"
      }
    },
    "ASSET_GROUPS": {
      "STABLECOINS": "Stablecoins",
      "BLUE_CHIPS": "Blue chips",
      "TOP_ALTCOINS": "Top altcoins",
      "OTHER_ALTCOINS": "Otras altcoins",
      "INDICES": "Índices"
    },
    "DETAILS": {
      "ASSETS": "Activos",
      "YIELD_STRATEGY": "Estrategia de rendimiento",
      "APY_PROJECTION": "Proyección APY"
    }
  },
  "ASSET_DETAIL_SCREEN": {
    "BACK": "Atrás",
    "PROJECT_NOT_FOUND": "Proyecto no encontrado",
    "SETUP_STEPS": "Pasos de configuración",
    "GO_TO_PROJECT": "Ir al proyecto",
    "STATS": {
      "APY": "Rendimiento anual"
    },
    "STEPS": {
      "PREPARE_WEB3_WALLET": {
        "TITLE": "Preparar billetera Web3",
        "DESCRIPTION": "Instala y configura una billetera Web3 que soporte la red seleccionada. Por ejemplo, instala MetaMask para redes basadas en Ethereum, Phantom para Solana o Sui Wallet para la red Sui. Asegúrate de que tu billetera esté correctamente configurada y segura."
      },
      "CONNECT_NETWORK": {
        "TITLE": "Conectar red",
        "DESCRIPTION": "Agrega y conéctate a la red blockchain correcta en tu billetera. Si la red no se agrega automáticamente, es posible que debas agregarla manualmente usando la URL RPC de la red, Chain ID y otros detalles de la red. Asegúrate de estar conectado a la red correcta antes de continuar."
      },
      "CHECK_GAS_BALANCE": {
        "TITLE": "Verificar balance para comisiones",
        "DESCRIPTION": "Asegúrate de tener suficientes tokens nativos en tu billetera para cubrir las comisiones de transacción (gas). Para redes Ethereum necesitas ETH, para Solana - SOL, para Sui - SUI. La cantidad exacta necesaria dependerá de la congestión de la red y la complejidad de la transacción."
      },
      "PREPARE_ASSETS": {
        "TITLE": "Preparar activos",
        "DESCRIPTION": "Transfiere o adquiere los tokens específicos que deseas invertir (como USDC, USDT o DAI) a tu billetera conectada. Asegúrate de que los tokens estén en la red correcta - algunos tokens existen en múltiples redes pero no se pueden transferir directamente entre ellas."
      }
    }
  },
  "ERROR_SCREEN": {
    "TITLE": "¡Ups! Algo salió mal",
    "DEFAULT_MESSAGE": "Se produjo un error. Por favor, inténtelo de nuevo más tarde.",
    "RETRY_BUTTON": "Intentar de nuevo",
    "SPECIFIC_ERRORS": {
      "DOCKER": "El servicio no está disponible temporalmente. Por favor, inténtelo de nuevo en unos minutos.",
      "NETWORK": "Problema de conexión de red. Por favor, compruebe su conexión a Internet.",
      "SERVICE": "El servicio no está disponible temporalmente. Nuestro equipo está trabajando en ello.",
      "DATABASE": "Problema de acceso a la base de datos. Por favor, inténtelo de nuevo más tarde."
    }
  }
}; 